import { DOCUMENTATION_URL, VITE_DISCORD_URL } from "@/constants";
import { goto_documentation_event, goto_discord_event, goto_team_event } from "@/services/posthog/events";
import { useAnalytics } from "@/services/posthog/hooks";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";

export const useAppNavigation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const analytics = useAnalytics();

  const navigateToHome = () => {
    navigate({
      pathname: "/",
      search: searchParams.toString(),
    });
  };

  const navigateToData = () => {
    navigate({
      pathname: "/data",
      search: searchParams.toString(),
    });
  };

  const navigateToWorkspace = (workspaceId: string) => {
    navigate({
      pathname: `/workspace/${workspaceId}`,
      search: searchParams.toString(),
    });
  };

  const navigateToPromptbook = (promptbookId: string) => {
    navigate(`/promptbook/${promptbookId}`);
  };

  const navigateToSemanticModel = (semanticModelId: string) => {
    navigate({
      pathname: `/semantic_model/${semanticModelId}`,
      search: searchParams.toString(),
    });
  };

  const navigateToTeam = (teamId: string) => {
    analytics.capture(goto_team_event, { teamId });
    navigate({
      pathname: "/",
      search: createSearchParams({
        team: teamId,
      }).toString(),
    });
  };

  const navigateToPersonalWorkspace = () => {
    searchParams.delete("team");
    navigate({
      pathname: "/",
      search: searchParams.toString(),
    });
  };

  const navigateToDiscord = () => {
    analytics.capture(goto_discord_event);
    window.open(VITE_DISCORD_URL, "_blank", "rel=noopener noreferrer");
  };

  const navigateToDocumentation = () => {
    analytics.capture(goto_documentation_event);
    window.open(DOCUMENTATION_URL, "_blank");
  };

  const navigateBack = () => {
    navigate(-1);
  };

  const isHome = () => {
    return window.location.pathname === "/";
  };

  const isOnLLMs = () => {
    return window.location.pathname === "/llms";
  };

  const isOnDataPage = () => {
    return window.location.pathname === "/data";
  };

  return {
    navigateToHome,
    navigateToTeam,
    navigateToData,
    navigateToPersonalWorkspace,
    navigateToWorkspace,
    navigateToPromptbook,
    navigateToDiscord,
    navigateToDocumentation,
    navigateBack,
    isHome,
    isOnLLMs,
    isOnDataPage,
    navigateToSemanticModel,
  };
};
